<template>
    <v-container grid-list-md fluid>
        <v-row no-gutters class="d-flex justify-center">
            <v-col cols="12">
                <v-row no-gutters class="my-3 justify-start">
                    <v-col cols="2">
                        <v-menu open-on-hover offset-y location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-primary v-bind="props" block v-if="!$vuetify.display.mobile">
                                    Ajouter
                                </v-btn-primary>
                            </template>
                            <v-list nav>
                                <v-list-item
                                    @click="
                                        $router.push({
                                            name: 'new-export-office-sheet',
                                            params: { format: 'xlsx' },
                                        })
                                    "
                                >
                                    <v-list-item-title>Export XLSX</v-list-item-title>
                                    <template v-slot:append>
                                        <v-icon size="x-small">$fa-chevron-right</v-icon>
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    @click="
                                        $router.push({
                                            name: 'new-export-office-sheet',
                                            params: { format: 'docx' },
                                        })
                                    "
                                >
                                    <v-list-item-title>Export DOCX</v-list-item-title>
                                    <template v-slot:append>
                                        <v-icon size="x-small">$fa-chevron-right</v-icon>
                                    </template>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>
                    <v-col cols="8" class="pl-2">
                        <v-text-field
                            v-model="search"
                            append-inner-icon="$search"
                            label="Rechercher"
                            outlined
                            hide-details
                            clearable
                            @click:clear="search = ''"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="2" class="pl-2">
                        <v-combobox
                            v-model="filterCompany"
                            :items="allAvailableCompanies"
                            label="Société"
                            item-value="value"
                            dense
                            outlined
                            hide-details
                            :item-title="(item) => item.key"
                        >
                        </v-combobox>
                    </v-col>
                    <!-- <v-col cols="3">
                        <v-btn

                            color="secondary"
                            block
                            height="40px"
                            elevation="0"
                            class="rounded-lg gradient"
                            @click="$router.push({ name: 'new-export-office-sheet', params: { format: 'xlsx' }})"
                        >
                            Ajouter un export XLSX
                        </v-btn>
                    </v-col>
                    <v-col cols="3" class="pl-2">
                        <v-btn

                            color="secondary"
                            block
                            height="40px"
                            elevation="0"
                            class="rounded-lg gradient"
                            @click="$router.push({ name: 'new-export-office-sheet', params: { format: 'docx' }})"
                        >
                            Ajouter un export DOCX
                        </v-btn>
                    </v-col> -->
                </v-row>
            </v-col>
            <RuleTable
                :rule="'exportOffice'"
                :items="sortedItems"
                :actionFunction="getActions"
                :hideDuplication="true"
                :hideIntersection="true"
                :accountingCompanyId="accountingCompanyId"
                :maxHeight="maxHeightRT"
                @to-route="routeExportsOfficeEdition($event.id)"
                @delete="
                    patternToDelete = $event;
                    deleteDialog = true;
                "
            ></RuleTable>
        </v-row>
        <oss-dialog
            v-model="deleteDialog"
            title="Supprimer"
            :error="true"
            @close="patternToDelete = undefined"
            @valid="deletePattern"
            :validLoading="deleteLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer cette règle ?</h4>
        </oss-dialog>
    </v-container>
</template>
<script lang="ts">
import gql from "graphql-tag";
import { User } from "../../store/store";

import MULTIPLE_EXPORT_OFFICE from "../../graphql/exportOffice/MultipleExportOffice.gql";
import EXPORT_OFFICE_SCOPING from "../../graphql/exportOffice/ExportOfficesScoping.gql";
import DELETE_EXPORT_OFFICE from "../../graphql/exportOffice/DeleteExportOffice.gql";

import { Apollo } from "@/decorators";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import RuleTable from "./RuleTable.vue";

@Component({
    components: {
        RuleTable,
    },
})
export class ExportOffice extends Vue {
    patternCount = 0;

    pagination: any = {
        page: 1,
        rowsPerPage: 20,
        sortBy: "name",
    };

    firstRequestDone = false;

    loadingStateNext = true;

    search = "";

    filterCompany = null;

    get filterCompanyId() {
        debugger;
        return this.filterCompany?.key && this.filterCompany?.value
            ? this.filterCompany.value
            : null;
    }

    get allAvailableCompanies() {
        const companies = [];
        this.currentUser.allAvailableCompanies.forEach((company) => {
            companies.push({
                value: company.id,
                key: company.name,
            });
            companies.sort((a, b) => {
                if (a.key < b.key) return -1;
                if (a.key > b.key) return 1;
                return 0;
            });
        });
        companies.unshift({ value: "", key: "Toutes mes règles" });

        return companies;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingCompanyId() {
        return this.$store.state.user.company.id;
    }

    get sortedItems() {
        if (this.search) {
            return this.items
                .filter((item) => {
                    return item.name.toLowerCase().includes(this.search.toLowerCase());
                })
                .sort((a, b) => {
                    return a.name.localeCompare(b.name);
                });
        }
        return this.items.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }

    getActions(item) {
        let title = "Fichier associé: ";
        if (item.filename) {
            title += item.filename;
        }
        return title;
    }

    get maxHeightRT() {
        return "calc(100vh - 160px)";
        const innHeight = window.innerHeight;
        const vhHeight = (200 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    isRootProfile = false;

    @Apollo({
        query() {
            return this.filterCompanyId ? EXPORT_OFFICE_SCOPING : MULTIPLE_EXPORT_OFFICE;
        },
        variables() {
            return this.filterCompanyId
                ? { companyId: this.filterCompanyId }
                : { accountingCompany: this.accountingCompanyId };
        },
        skip() {
            return !this.accountingCompanyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            debugger;
            this.loading = loading;
            if (!loading) {
                if (data?.exportOffices?.length) {
                    this.firstRequestDone = true;
                    this.items.push(...data.exportOffices);
                } else {
                    if (data?.exportOfficesScoping?.length) {
                        this.firstRequestDone = true;
                        this.items.push(...data.exportOfficesScoping);
                    } else {
                        this.items = [];
                    }
                }
            }
        },
    })
    items: Array<any> = [
        // {
        //     id: "cloenc4cr0002vmqout3cx7wd",
        //     name: "Exportation de Immeubles",
        //     filename: "empty.xlsx",
        //     exports: [{
        //         name: "buildings",
        //         options: {},
        //         position: {
        //             startRow: "2",
        //             worksheet: "Test2",
        //             startColumn: "B"
        //         }
        //     }],
        //     companyScope: {
        //         id: ""
        //     }
        // }
    ];

    // onIntersectNext(_, entries, observer) {
    //     if (this.firstRequestDone) {
    //         if (entries[0].isIntersecting) {
    //             this.loadingStateNext = true;
    //             this.pagination.page += 1;
    //             console.log(this.pagination.rowsPerPage);
    //         }
    //     }
    // }

    routeExportsOfficeEdition(id) {
        this.$router.push({
            name: "export-office-sheet",
            params: {
                id: id,
            },
        });
    }

    patternToDelete;
    deleteDialog = false;
    deleteLoading = false;

    async deletePattern() {
        this.deleteLoading = true;
        if (this.patternToDelete) {
            await this.$apollo.mutate({
                mutation: DELETE_EXPORT_OFFICE,
                variables: {
                    id: this.patternToDelete.id,
                },
            });
            this.patternToDelete = undefined;
            this.refresh();
        }
        this.deleteDialog = false;
        this.deleteLoading = false;
    }

    refresh() {
        this.items = [];
        if (this.$apollo.queries && this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
        } else {
            debugger;
        }
    }

    @Watch("filterCompanyId")
    filterCompanyIdWatch() {
        this.$apollo.queries.items.refetch();
    }
}

export default toNative(ExportOffice);
</script>
